<template>
  <div class="bg-grid" :class="{ 'bg-grid_loaded': isLoaded }">
    <div class="container bg-grid__container">
      <div class="bg-grid__inner">
        <div class="bg-grid__group-lines">
          <div class="bg-grid__line-item"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BackgroundGrid',
  props: {
    isLoaded: {
      type: Boolean,
      default: false
    }
  }
}
</script>
